import arrow from "@assets/redesign/icons/arrowRight.svg";
import icon_sort_ex from "@assets/redesign/icons/arrow.svg";
import Error from "@components/global/new/Error/Error";
import Icon from "@components/global/new/Icon/Icon";
import cn from "classnames";
import Option from "./Option/Option";
import styles from "./PeriodOptions.module.scss";
import { usePeriodOptionsControl } from "./usePeriodOptionsControl";
import WeekPlanExcluder from "./WeekPlanExcluder/WeekPlanExcluder";
import { useIntl } from "react-intl";
import addIcon from "@assets/redesign/icons/addOutlined.svg";

interface IPeriodOptionsProps {
  readonly showSaveTemplate: boolean;
  onDeletePeriod(idx: number): void;
  onAddPeriods?(): void;
}

interface DragItem {
  id: number;
  text: string;
}

export default function PeriodOptions(props: IPeriodOptionsProps) {

  //const { formatMessage } = useIntl();
  const control = usePeriodOptionsControl();

  return (
    <div className={styles.form_wrapper} id="test-element">
      <div
        className={cn(styles.wrapper, {
          [styles.readOnly]: control.readOnly,
          [styles.outlined]: !control.disabled,
        })}
      >
        <div className={styles.header}>
          {/*!control.disabled && (
            <Icon
              src={icon_sort_ex}
              className={styles.icon_sort}
              title={formatMessage({ id: "common.sort" })}
              onClick={() => {
                control.sortCurrentPeriods()
              }}
            />
          )*/}
          <span>Active</span>
          <span>Pause</span>
          {!control.disabled && (
            <div className={styles.controls}>
              {control.current.length > 0 && props.showSaveTemplate && (<Icon
                src={arrow}
                className={styles.download_icon}
                onClick={control.onSavePeriodsTemplate}
                noHover
              />)}
              {props.onAddPeriods && control.selectedDays.length > 0 && (
                <Icon src={addIcon} className={cn(styles.add)} onClick={props.onAddPeriods} noHover />
              )}
            </div>
          )}
        </div>
        {/*{(control.current.length > 0 || control.weekDayPeriods) && (*/}
        <div className={`${styles.periods} ${styles.open}`}>
          <WeekPlanExcluder />
          {control.current.map((pick, i) => (
            <div
              key={i}
              className={styles.drag_anchor}
              draggable={!control.disabled}
              onDragStart={(e) => control.handleDragStart(e, pick, i)}
              onDragOver={control.handleDragOver}
              onDrop={(e) => control.handleDrop(e, i)}
            >
              <Option
                id={i}
                key={i}
                rowNum={i}
                isError={false}
                option={pick.time}
                onOpenChanged={(value) => {

                }}
                onDeletePeriod={props.onDeletePeriod}
              />
            </div>
          ))}
          {control.errors?.ownError && (
            <Error errors={control.errors} />
          )}
          {/* {(control.errors?.ownError?.includes("период") ||
            control.errors?.ownError?.includes("period")) && (
            <Error errors={control.errors} />
          )} */}
        </div>
        {/*})}*/}
      </div>
    </div>
  );
}